export default "__VITE_ASSET__BhqduS02__"